import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Spinner } from 'react-bootstrap';

/**
 * Nastavení variant
 *
 * - uložení - primary
 */

export interface ButtonProps {
  size?: string;
  variant?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'warning'
    | 'danger'
    | 'info'
    | 'indigo'
    | 'purple'
    | 'pink'
    | 'teal'
    | 'light'
    | 'dark'
    | 'link';
  type?: 'submit' | 'reset' | 'button' | undefined;
  className?: string;
  disabled?: boolean;
  block?: boolean;
  autoFocus?: boolean;
  beforeIcon?: IconProp | undefined;
  loading?: boolean;
  style?: any;
  children?: React.ReactNode[] | React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
}

const Button = ({ type, ...props }: ButtonProps) => {
  const onClick = (e: any) => {
    if (props.onClick) {
      props.onClick(e);
    }
  };

  const size = props.size || 'sm';

  const classNames = ['btn'];
  if (size) {
    classNames.push(`btn-${size}`);
  }
  classNames.push(`btn-${props.variant || 'primary'}`);
  if (props.block === true) {
    classNames.push('btn-block');
  }
  if (props.className) {
    classNames.push(props.className);
  }

  return (
    <button
      disabled={props.disabled === true}
      className={classNames.join(' ')}
      type={type}
      autoFocus={props.autoFocus === true}
      onClick={onClick}
      style={props.style}
    >
      {props.loading && <Spinner size="sm" animation="border" />}
      {props.beforeIcon && (
        <>
          <FontAwesomeIcon icon={props.beforeIcon} />
          {` `}
        </>
      )}
      {props.children}
    </button>
  );
};

export default Button;
